import { IImbpSmartMeterOfferedSlot } from "./imbpSmartMeterOfferedSlot.types"
import dayjs from "dayjs"
import { isAmOrPm } from "@/helpers/dateHelper"

export class ImbpSmartMeterOfferedSlot implements IImbpSmartMeterOfferedSlot {
  appointmentStart: string
  appointmentEnd: string
  dateOffered: string
  channel: string
  installer: string | null

  constructor(
    appointmentStart: string,
    appointmentEnd: string,
    dateOffered: string,
    channel: string,
    installer: string | null,
  ) {
    this.appointmentStart = appointmentStart
    this.appointmentEnd = appointmentEnd
    this.dateOffered = dateOffered
    this.channel = channel
    this.installer = installer
  }

  get appointmentSlotFormatted(): string {
    const appointmentLabel = dayjs(this.appointmentStart).format(
      "ddd D MMM YYYY",
    )
    const period = isAmOrPm(this.appointmentStart)

    return `${appointmentLabel} - ${period}`
  }

  get dateOfferedFormatted(): string {
    return dayjs(this.dateOffered).format("D MMM YYYY")
  }

  get installerLabel(): string {
    switch (this.installer) {
      case "AES":
        return "AES"
      case "SMS":
        return "SMS"
      default:
        return "AES"
    }
  }
}
